import { IGradientVariant } from '../types';
import { EnhancedGradientBorderColor } from '../../../config';

export const GRADIENT_VARIANT_TO_GRADIENT: Record<IGradientVariant, string> = {
  enhanced: EnhancedGradientBorderColor
};
